/* DON'T EDIT THIS FILE: edit original and run build again */ import { ChevronRightIcon } from "../../framework/theme-icons/icon.ts";
import { LoadingButton } from "../../framework/theme/loading-button.tsx";

export const SaveButton = ({
  children,
  variant = "primary",
  className = "",
  onClick,
  disabled,
}: {
  children: React.ReactNode;
  variant?: string;
  className?: string;
  onClick: (
    e: React.MouseEvent<HTMLButtonElement, MouseEvent>
  ) => Promise<void>;
  disabled?: boolean;
}) => (
  <LoadingButton
    variant={variant}
    disabled={disabled}
    onClick={onClick}
    className={"flex-nowrap align-items-center " + className}
  >
    {children}
    <ChevronRightIcon className="ms-1 icon-1" />
  </LoadingButton>
);
